import { render, staticRenderFns } from "./FailReceive.vue?vue&type=template&id=244751d3&scoped=true&"
import script from "./FailReceive.vue?vue&type=script&lang=js&"
export * from "./FailReceive.vue?vue&type=script&lang=js&"
import style0 from "./FailReceive.vue?vue&type=style&index=0&id=244751d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244751d3",
  null
  
)

export default component.exports